import React, { useState, useEffect } from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import { Link } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
// import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
import Slider from "react-slick";
import Skeleton from "react-loading-skeleton";
import FsLightbox from "fslightbox-react";

// helpers
import { converCryptoToDollar } from "helpers/constants";
import Web3Intraction from "utils/web3Intraction";

// Hooks
import useMetaMask from "hooks/metsmask";

// Components
import TimeCountDown from "Component/TimeCoundDown/TimeCountDown";
import Addfund from "Component/Addfund/Addfund";
import LikeButton from "Component/Liked/LikeButton";
import { AddFundModal } from "Component/Addfund/AddFundModal";

// Store
import {
  getCollection,
  getItemByToken,
  postBidAction,
  getCurrentUser,
  postItemBuy,
  postBid,
  deleteBid,
} from "store/actions";

// moment
import moment from "moment-timezone";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <svg width="20" height="20" viewBox="0 0 20 20">
        <path fill="#000" d="M7 1L5.6 2.5L13 10l-7.4 7.5L7 19l9-9z" />
      </svg>
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style }} onClick={onClick}>
      <svg width="20" height="20" viewBox="0 0 20 20">
        <path fill="#000" d="m4 10l9 9l1.4-1.5L7 10l7.4-7.5L13 1z" />
      </svg>
    </div>
  );
}

const Biddingpage = (props) => {
  const { isLiked, getLikedPost } = props;
  const queryParams = new URLSearchParams(window.location.search);
  const itemId = queryParams.get("id");

  const hooks = useMetaMask();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  let walletAddress = localStorage.getItem("walletAddress");

  const { item, itemDetails, loading } = useSelector((state) => state?.items);
  const { user, settings, authToken } = useSelector((state) => state?.Login);

  const [price, setprice] = useState();
  const [toggler, setToggler] = useState(false);
  const [state, setState] = useState({ tab: "tab1" });
  const [show, setShow] = useState(false);
  const [bidLoading, setBidLoading] = useState(false);
  const [isBid, setisBid] = useState(false);

  const [showAddFundModal, setShowAddFundModal] = useState(false);
  const [internalLoading, setinternalLoading] = useState(false);
  const [isCurrentUser, setisCurrentUser] = useState(false);
  const [placebidLoading, setplacebidLoading] = useState(false);
  const [sessionExpired, setsessionExpired] = useState(false);
  const [usdPrice, setUsdPrice] = useState();

  var settingsslider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const calPrice = async () => {
    let amount = item?.price;
    let symbol = item?.blockchain == "polygon" ? "MATIC" : item?.blockchain;
    let data = await converCryptoToDollar(amount, symbol);
    setUsdPrice((pre) => ({
      ...pre,
      data,
    }));
  };

  useEffect(() => {
    calPrice();
  }, [item]);

  const BuyNow = (evt) => {
    evt.preventDefault();
    if (settings && item && JSON.stringify(item) !== "{}") {
      if (!window.ethereum) {
        toastr.error(
          "Connect your Metamask wallet to update the message on the blockchain."
        );
        return;
      }
      setinternalLoading(true);
      const web3intraction = new Web3Intraction(
        item?.blockchain,
        hooks?.walletType,
        settings
      );
      if (!web3intraction.isNetworkServiceWorking()) {
        return toastr.error("Service Not Available!");
      }
      const getCollectionData = async (response) => {
        try {
          await web3intraction.verifyApproved(
            user?.walletAddress,
            response,
            () => console.log("")
          );
          const receipt = await web3intraction.sendTransaction(
            user?.walletAddress,
            item,
            () => console.log(""),
            user?.walletAddres
          );
          const data = {
            type: item?.blockchain || "ethereum",
            itemId: item?._id,
            transactionHash: receipt?.transactionHash,
          };

          dispatch(
            postItemBuy(data, () => {
              dispatch(
                getItemByToken(itemId, () => {
                  setinternalLoading(false);
                })
              );
            })
          );
        } catch (error) {
          console.log("error", error);
          setinternalLoading(false);
        }
      };

      web3intraction
        .switchChain()
        .then(() =>
          dispatch(getCollection(item?.collection_id?._id, getCollectionData))
        )
        .catch((error) => {
          toastr.error(error?.message);
          setinternalLoading(false);
        });
    }
  };

  const onBid = (evt) => {
    evt.preventDefault();

    if (!walletAddress) {
      return toastr.error("Please Connect your Metamask");
    }

    if (price == undefined || price == 0) {
      return setTimeout(() => {
        toastr.error("Please enter Price !!");
      }, 300);
    }

    setplacebidLoading(true);
    try {
      const data = {
        type: item.blockchain || "ethereum",
        itemId: item?._id,
        price,
      };

      dispatch(
        postBid(data, (res) => {
          dispatch(getItemByToken(itemId));
          toastr.success(res.message);
          setisBid(false);
          setprice("");
        })
      );
      setplacebidLoading(false);
    } catch (error) {
      setplacebidLoading(false);
      toastr.error(error.message);
    }
  };

  const acceptOffer = () => {
    const callback = (response) => {
      if (response.status === "success") {
        toastr.success(response.message);
        dispatch(getItemByToken(itemId));
      } else {
        toastr.error(response.message);
      }
    };

    dispatch(
      postBidAction(
        {
          offer_id: itemDetails?.bidsHistory[0]?._id,
          itemId: itemDetails?.bidsHistory[0]?.item?._id,
          type: itemDetails?.bidsHistory[0]?.item?.blockchain,
          actionType: "accept",
        },
        callback
      )
    );
  };

  const rejectOffer = () => {
    const callback = (response) => {
      if (response.status === "success") {
        toastr.success(response.message);
        dispatch(getItemByToken(itemId));
      } else {
        toastr.error(response.message);
      }
    };

    dispatch(
      postBidAction(
        {
          offer_id: itemDetails?.bidsHistory[0]?._id,
          itemId: itemDetails?.bidsHistory[0]?.item._id,
          type: itemDetails?.bidsHistory[0]?.item?.blockchain,
          actionType: "cancel",
        },
        callback
      )
    );
  };

  const deleteOffer = () => {
    const callback = (response) => {
      if (response.status === "success") {
        toastr.success(response.message);
        dispatch(getItemByToken(itemId));
      } else {
        toastr.error(response.message);
      }
    };
    dispatch(
      deleteBid(
        {
          offer_id: itemDetails?.bidsHistory[0]?._id,
          itemId: itemDetails?.bidsHistory[0]?.item._id,
        },
        callback
      )
    );
  };

  const paymentOffer = (transactionReceipt) => {
    const callback = (response) => {
      if (response.status === "success") {
        dispatch(getItemByToken(itemId));
      }
    };
    dispatch(
      postBidAction(
        {
          transactionHash: transactionReceipt?.transactionHash,
          offer_id: itemDetails?.bidsHistory[0]?._id,
          itemId: item?._id,
          type: item?.blockchain || "ethereum",
          actionType: "payment",
        },
        callback
      )
    );
  };

  const onBidPayment = (item, afterPayment) => {
    if (user?.walletAddress == item?.current_owner?.walletAddress) {
      return toastr.error("Switch your WalletAddress!!");
    }
    if (settings && item && JSON.stringify(item) !== "{}") {
      if (!window.ethereum) {
        toastr.error(
          "Connect your Metamask wallet to update the message on the blockchain."
        );
        return;
      }
      setBidLoading(true);
      const web3intraction = new Web3Intraction(
        item?.blockchain,
        hooks?.walletType,
        settings
      );

      if (!web3intraction.isNetworkServiceWorking()) {
        return toastr.error("Service Not Available!");
      }
      const getCollectionData = async (response) => {
        try {
          await web3intraction.verifyApproved(
            user?.walletAddress,
            response,
            () => console.log("")
          );
          const receipt = await web3intraction.sendTransaction(
            user?.walletAddress,
            item,
            () => console.log("")
          );

          afterPayment && afterPayment(receipt);
          dispatch(dispatch(getItemByToken(itemId)));
          setBidLoading(false);
        } catch (error) {
          setBidLoading(false);
        }
      };

      web3intraction
        .switchChain()
        .then(() =>
          dispatch(getCollection(item?.collection_id?._id, getCollectionData))
        )
        .catch((error) => {
          toastr.error(error?.message);
          setBidLoading(false);
        });
    }
  };

  const Nav = () => {
    if (!authToken) {
      toastr.error("Please Login");
    } else {
      navigate("/metamask-sign");
    }
  };

  const bidInputToggle = () => {
    if (!walletAddress) {
      setisBid(false);
    } else {
      setisBid(true);
    }
  };

  useEffect(() => {
    if (itemId) {
      dispatch(getItemByToken(itemId));
    }
  }, [itemId]);

  useEffect(() => {
    if (user?._id === item?.current_owner?._id) {
      setisCurrentUser(true);
    } else {
      setisCurrentUser(false);
    }
  }, [user, item]);

  useEffect(() => {
    if (
      item?.saleType == "auction" &&
      item?.minted_end_date &&
      item?.status !== "created"
    ) {
      setsessionExpired(false);
    }
  }, [item]);

  useEffect(() => {
    dispatch(getCurrentUser());
  }, []);

  return (
    <section className="Biddingpage-main">
      <Addfund
        show={show}
        handleClose={handleClose}
        handleShow={() => setShowAddFundModal(true)}
      />

      <AddFundModal
        visible={showAddFundModal}
        onClose={() => setShowAddFundModal(false)}
      />

      <Container>
        <Row>
          <Col lg={5} md={6} sm={12}>
            <div className="bidding-left position-relative">
              <>
                <FsLightbox
                  toggler={toggler}
                  sources={[itemDetails?.data?.media?.link]}
                />
              </>
              {itemDetails?.data?.media?.link ? (
                <img
                  src={itemDetails?.data?.media?.link}
                  alt="alt"
                  className="img-fluid"
                  // onClick={() => setToggler(!toggler)}
                />
              ) : (
                <div className="card__image loading"></div>
              )}
              <div>
                <LikeButton
                  liked={itemDetails?.isLiked || isLiked}
                  itemId={itemDetails?._id}
                  getLikedPost={getLikedPost}
                />
              </div>

              <button
                className="view_screen"
                onClick={() => setToggler(!toggler)}
              >
                View on Full Screen
              </button>
            </div>

            <div className="thumb_slider mt-2">
              <Slider {...settingsslider}>
                {itemDetails?.data?.relatedImages &&
                  itemDetails?.data?.relatedImages.map((img) => {
                    return img?.mimeType == "image" ? (
                      <div className="boxone">
                        <img src={img?.link} alt="alt" className="img-fluid" />
                      </div>
                    ) : img?.mimeType == "video" ? (
                      <div className="boxone">
                        <video controls>
                          <source src={img?.link} type="video/mp4" />
                        </video>
                      </div>
                    ) : img?.mimeType == "audio" ? (
                      <div className="boxone">
                        <audio src={img?.link} controls />
                      </div>
                    ) : (
                      <div className="boxone">
                        <img src={img?.link} alt="alt" className="img-fluid" />
                      </div>
                    );
                  })}
              </Slider>
            </div>
          </Col>

          <Col lg={7} md={6} sm={12}>
            <div className="biddingpalce-details">
              <h2>{itemDetails?.data?.name}</h2>

              <div className="verified-bidiing-wrap">
                <div className="verified-user-wrap">
                  <div className="verified-user-img">
                    <img
                      src={
                        itemDetails?.data?.author_id?.profileImage?.link ||
                        "images/avatar.png"
                      }
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <div className="verified-user-cont">
                    <h5>Creator </h5>
                    <Link
                      className="link-text"
                      to={`/profile?id=${itemDetails?.data?.author_id?._id}`}
                    >
                      <p>{itemDetails?.data?.author_id?.name}</p>
                    </Link>
                  </div>
                </div>

                <div className="verified-user-wrap">
                  <div className="verified-user-img">
                    <img
                      src={
                        itemDetails?.data?.collection_id?.image?.link ||
                        "images/avatar.png"
                      }
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <div className="verified-user-cont">
                    <h5>Collection</h5>
                    <Link
                      className="link-text"
                      to={`/card-profile?id=${item?.collection_id?.contractAddress}`}
                    >
                      <p>{itemDetails?.data?.collection_id?.name}</p>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="d-flex">
                <p className="Price-detail">
                  Current Price - {item?.price}
                  {item?.blockchain == "polygon" ? (
                    <img className="polygon_icon_home" src="/images/poly.png" />
                  ) : item?.blockchain == "BNB" ? (
                    <img className="eth_icon" src="/images/bnb.png" />
                  ) : (
                    <img className="eth_icon" src="/images/eth.png" />
                  )}
                </p>

                <p className="Price-detail">
                  Price in USD :
                  <img className="polygon_icon_home" src="/images/dollor.png" />
                  <span> {usdPrice?.data || ""}</span>
                </p>
              </div>

              {item?.minted_end_date && item?.status == "active" ? (
                <div className="py-9 ">
                  {loading ? (
                    <div className="skeleton-div">
                      <Skeleton count={3} />
                    </div>
                  ) : (
                    <TimeCountDown
                      leftDate={item?.minted_end_date}
                      item={item}
                      user={user}
                      setsessionExpired={setsessionExpired}
                    />
                  )}
                </div>
              ) : null}

              {item?.status !== "inactive" && (
                <>
                  {itemDetails?.bidsHistory?.[0]?.status !== "accepted" ? (
                    <>
                      {!isCurrentUser && (
                        <div className="biddding-form">
                          <Form className="registration-here">
                            {isBid ? (
                              <FormGroup className="position-relative">
                                <Label htmlFor="exampleEmail">Current Bid</Label>
                                <Input
                                  type="number"
                                  name="price"
                                  min=".0000000000000000000000000001"
                                  value={price}
                                  onChange={(evt) => setprice(evt.target.value)}
                                  placeholder="1.000 USD(≈ $3,221.22)"
                                  required
                                />
                              </FormGroup>
                            ) : null}

                            {!loading ? (
                              <>
                                {!sessionExpired &&
                                  authToken &&
                                  item?.status !== "created" && (
                                    <div className="wrappimg_btns">
                                      {!walletAddress ? (
                                        <div className="btn-blcksboth">
                                          <Button
                                            className="btn-commonblack"
                                            onClick={Nav}
                                          >
                                            <img src="images/metamask.png" />
                                            Metamask
                                          </Button>
                                        </div>
                                      ) : null}
                                      <div>
                                        <Button
                                          onClick={(evt) => {
                                            onBid(evt);
                                            bidInputToggle();
                                          }}
                                          className="placebid-btn"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <path
                                              d="M20 3H5C3.346 3 2 4.346 2 6V18C2 19.654 3.346 21 5 21H20C21.103 21 22 20.103 22 19V5C22 3.897 21.103 3 20 3ZM5 19C4.448 19 4 18.551 4 18V6C4 5.449 4.448 5 5 5H20V8H14C12.897 8 12 8.897 12 10V14C12 15.103 12.897 16 14 16H20.001V19H5ZM20 10V14H14V10H20Z"
                                              fill="black"
                                            />
                                          </svg>
                                          {loading ||
                                            (placebidLoading && (
                                              <Spinner
                                                variant="warning"
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                              ></Spinner>
                                            ))}
                                          Place a Bid
                                        </Button>
                                      </div>
                                    </div>
                                  )}
                              </>
                            ) : (
                              <div className="bid_button_selaton">
                                <Skeleton count={1} />
                              </div>
                            )}

                            {!walletAddress ? null : (
                              <div className="btn-blcksboth">
                                {item?.saleType !== "auction" &&
                                  item?.status !== "created" &&
                                  authToken && (
                                    <>
                                      {!sessionExpired ? (
                                        <>
                                          {!loading ? (
                                            <>
                                              <Button
                                                onClick={handleShow}
                                                className="btn-commonblack"
                                              >
                                                Fiat Currency
                                              </Button>

                                              <Button
                                                type="submit"
                                                className="btn-commonblack"
                                                onClick={BuyNow}
                                              >
                                                {internalLoading && (
                                                  <Spinner
                                                    variant="warning"
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                  ></Spinner>
                                                )}
                                                Buy
                                              </Button>
                                            </>
                                          ) : null}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  )}
                              </div>
                            )}
                          </Form>
                        </div>
                      )}
                    </>
                  ) : null}
                </>
              )}
            </div>
          </Col>
        </Row>

        <div className="description-area">
          <Row>
            <Col lg={6} md={6} sm={12}>
              <div className="description-left descriptionbiidng">
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Description</Accordion.Header>
                    <Accordion.Body>
                      {itemDetails?.data?.description}
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>Details</Accordion.Header>
                    <Accordion.Body>
                      <p>Price - {itemDetails?.data?.price}</p>

                      <p>
                        Contract Address<br></br>
                        <a
                          style={{ textDecoration: "none" }}
                          href={
                            item?.collection_id?.blockchain === "polygon"
                              ? `https://mumbai.polygonscan.com/address/` +
                                item?.collection_id?.contractAddress
                              : item?.collection_id?.blockchain === "ethereum"
                              ? `https://etherscan.io/address/` +
                                item?.collection_id?.contractAddress
                              : item?.collection_id?.blockchain === "BNB"
                              ? `https://testnet.bscscan.com/address/` +
                                item?.collection_id?.contractAddress
                              : ""
                          }
                          target="_blank"
                        >
                          {item?.collection_id?.contractAddress}
                        </a>
                      </p>
                      <p>Blockchain - {itemDetails?.data?.blockchain}</p>

                      <p>Token ID - {itemDetails?.data?.token_id}</p>
                      <p>
                        Creator Earning -
                        {itemDetails?.data?.collection_id?.creatorEarning}
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </Col>

            <Col lg={6} md={6} sm={12}>
              <div className="description-right">
                <div className="tab-frame bidding-frame">
                  <div className="clearfix">
                    <input
                      type="radio"
                      name="tab"
                      id="tab1"
                      checked={state?.tab == "tab1"}
                      onClick={() => setState({ tab: "tab1" })}
                    />
                    <label htmlFor="tab1">Bid History</label>

                    <input
                      type="radio"
                      name="tab"
                      id="tab2"
                      checked={state?.tab == "tab2"}
                      onClick={() => setState({ tab: "tab2" })}
                    />
                    <label htmlFor="tab2">Provenance</label>

                    <input
                      type="radio"
                      name="tab"
                      id="tab3"
                      checked={state?.tab == "tab3"}
                      onClick={() => setState({ tab: "tab3" })}
                    />
                    <label htmlFor="tab3">Owner</label>
                  </div>

                  {state?.tab == "tab1" && (
                    <ul>
                      {itemDetails &&
                      itemDetails?.bidsHistory?.[0]?.status !== "expired" &&
                      itemDetails?.bidsHistory?.length > 0 ? (
                        itemDetails?.bidsHistory?.map((bid, index) => {
                          return (
                            <>

                              {user?._id ===
                                itemDetails?.bidsHistory[index]?.to?._id && (
                                <>
                                  {itemDetails?.bidsHistory[index]?.status !==
                                    "accepted" && (
                                    <div className="carddetails-tab">
                                      <div className="bids-div">
                                        <div className="divwrapping">
                                          <div className="user-hereshow">
                                            <div className="user-imgshow">
                                              <img
                                                src={
                                                  bid?.from?.profileImage
                                                    ?.link ||
                                                  "images/avatar.png"
                                                }
                                                alt="profile-image"
                                                className="img-fluid"
                                              />
                                            </div>

                                            <div className="user-contentshow">
                                              <p>
                                                {bid?.price} ,
                                                {bid?.item?.blockchain}- by,
                                                {bid?.from?.name} To
                                                <span className="bid_name_text">
                                                  {bid?.to?.name}
                                                </span>
                                              </p>

                                              <p className="small">
                                                {moment(
                                                  bid?.created_date
                                                )?.format("MMM-DD , yyy")}
                                              </p>
                                            </div>
                                          </div>

                                          {item?.saleType !== "auction" ? (
                                            <div className="btn-both">
                                              <Button
                                                onClick={(e) => {
                                                  acceptOffer();
                                                }}
                                                className="btn-accpt btn-common"
                                              >
                                                {loading ? (
                                                  <div className="spinner">
                                                    <Spinner
                                                      as="span"
                                                      animation="border"
                                                      size="sm"
                                                      role="status"
                                                      aria-hidden="true"
                                                    />
                                                    <span className="">
                                                      Accept.
                                                    </span>
                                                  </div>
                                                ) : (
                                                  "Accept"
                                                )}
                                              </Button>
                                              <Button
                                                disabled={
                                                  loading ? true : false
                                                }
                                                onClick={(e) => {
                                                  rejectOffer();
                                                }}
                                                className="btn-reject btn-common"
                                              >
                                                Reject
                                              </Button>
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}

                              {user?._id ===
                                itemDetails?.bidsHistory[index]?.from?._id && (
                                <>
                                  {itemDetails?.bidsHistory[index]?.status ===
                                    "accepted" && (
                                    <div className="carddetails-tab">
                                      <div className="bids-div">
                                        <div className="divwrapping">
                                          <div className="user-hereshow">
                                            <div className="user-imgshow">
                                              <img
                                                src={
                                                  bid?.to?.profileImage?.link ||
                                                  "images/avatar.png"
                                                }
                                                className="img-fluid"
                                              />
                                            </div>
                                            <div className="user-contentshow">
                                              <p>
                                                {bid?.price} ,
                                                {bid?.item?.blockchain}- Accept
                                                ,{bid?.to?.name}
                                              </p>
                                              <p className="small">
                                                {moment(
                                                  bid?.created_date
                                                )?.format("MMM-DD , yyy")}
                                              </p>
                                            </div>
                                          </div>

                                          <div className="btn-both">
                                            {loading || bidLoading ? (
                                              <Button
                                                type="submit"
                                                className="btn-commonblack"
                                              >
                                                <Spinner
                                                  animation="border"
                                                  role="status"
                                                ></Spinner>
                                              </Button>
                                            ) : (
                                              <Button
                                                onClick={(e) => {
                                                  onBidPayment(
                                                    {
                                                      ...item,
                                                      price:
                                                        itemDetails
                                                          ?.bidsHistory[0]
                                                          ?.price,
                                                    },
                                                    (transactionReceipt) =>
                                                      paymentOffer(
                                                        transactionReceipt
                                                      )
                                                  );
                                                }}
                                                className="btn-accpt btn-common"
                                              >
                                                Payment
                                              </Button>
                                            )}

                                            <Button
                                              onClick={(e) => {
                                                e.preventDefault();
                                                deleteOffer();
                                              }}
                                              className="btn-reject btn-common"
                                            >
                                              Cancel
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          );
                        })
                      ) : (
                        <span className="no_bid_text"> No Bid Found !! </span>
                      )}
                    </ul>
                  )}

                  {state.tab == "tab2" && (
                    <div className="bidding-tabbox">
                      <ul>
                        <li>
                          <div className="list-wrap">
                            <div className="list-img">
                              <img
                                src={
                                  itemDetails?.data?.author_id?.profileImage
                                    ?.link || "images/avatar.png"
                                }
                                alt=""
                                className="img-fluid user-icon"
                              />
                            </div>
                            <div className="list-cont">
                              <p>
                                Listed by - {itemDetails?.data?.author_id?.name}
                              </p>
                              <p>
                                {moment(
                                  itemDetails?.data?.author_id?.date_created
                                ).format("MM-DD-yy")}
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  )}

                  {state.tab == "tab3" && (
                    <div className="bidding-tabbox">
                      <ul>
                        <li>
                          <div className="list-wrap">
                            <div className="list-img">
                              <img
                                src={
                                  itemDetails?.data?.current_owner?.profileImage
                                    ?.link
                                }
                                alt=""
                                className="img-fluid bid-img"
                              />
                            </div>
                            <div className="list-cont">
                              <p>
                                Current Owner -
                                {itemDetails?.data?.current_owner?.name}
                              </p>
                              <p>
                                Created Date -
                                <span>
                                  {moment(
                                    itemDetails?.data?.author_id?.date_created
                                  ).format("MMM- DD , yyy A ")}
                                </span>
                              </p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default Biddingpage;
